import { types } from 'mobx-state-tree'

export default types.model('SortingModel', {
  field: '',
  direction: ''
})
